import React, { useState } from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function SocialProofSection() {
  return <div className="w-full bg-slate-50" data-id="element-299">
      {/* SECTION 10 - TESTIMONIOS EXTENDIDOS */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-300">
        <div className="text-center mb-16" data-id="element-301">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-slate-900 mb-4" data-id="element-302">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl font-bold text-slate-700" data-id="element-303">
            4.9/5{' '}
            <div className="flex text-yellow-400" data-id="element-304">
              <Star className="w-6 h-6 fill-current" data-id="element-305" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-306">
          <TestimonialCard initials="MP" name="Martín P." city="Buenos Aires 🇦🇷" quote="Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso." data-id="element-307" />
          <TestimonialCard initials="CG" name="Carolina G." city="Córdoba 🇦🇷" quote="Tres alumnos de nivel inicial que estaban estancados mejoraron su posición en cancha en el primer mes con el Tomo 2." data-id="element-308" />
          <TestimonialCard initials="FR" name="Federico R." city="Rosario 🇦🇷" quote="Antes tardaba 1 hora armando la clase. Ahora abro el tomo, veo el drill y en 5 minutos entro a la cancha." data-id="element-309" />
          <TestimonialCard initials="SV" name="Sofía V." city="Mendoza 🇦🇷" quote="El Nivelómetro me cambió la vida. Antes ponía a los alumnos a ojo. Ahora los clasifico en 5 minutos y mis grupos son mucho más parejos." data-id="element-310" />
          <TestimonialCard initials="DA" name="Diego A." city="Santa Fe 🇦🇷" quote="Los diagramas de cancha son un lujo. Los imprimo y los uso en la clase para mostrarle al alumno dónde tiene que estar. Se entiende todo de inmediato." data-id="element-311" />
          <TestimonialCard initials="LR" name="Laura R." city="Tucumán 🇦🇷" quote="El Kit de Supervivencia me salvó dos veces este mes. Una vez que llegó un alumno nuevo sin aviso y otra que el encargado no dejó el depósito abierto." data-id="element-312" />
        </div>
      </section>

      {/* SECTION 11 - GARANTÍA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-313">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl border-2 border-blue-100 shadow-xl overflow-hidden" data-id="element-314">
          <div className="bg-blue-600 p-6 text-center" data-id="element-315">
            <ShieldCheck className="w-16 h-16 text-white mx-auto mb-4" data-id="element-316" />
            <h2 className="text-3xl font-heading font-bold text-white" data-id="element-317">
              Garantía 7 días sin preguntas
            </h2>
          </div>
          <div className="p-8 md:p-12 text-center text-lg text-slate-700 font-medium leading-relaxed" data-id="element-318">
            <p className="mb-2" data-id="element-319">Abrí los 12 Tomos.</p>
            <p className="mb-2" data-id="element-320">Revisá los 6 Bonus.</p>
            <p className="mb-6" data-id="element-321">Usá los Ebooks Élite en tu clase.</p>

            <p className="font-bold text-slate-900 mb-2" data-id="element-322">
              Si no es lo que esperabas →
            </p>
            <p className="text-blue-600 font-bold text-2xl mb-6" data-id="element-323">
              100% de devolución.
            </p>

            <p className="mb-8" data-id="element-324">Sin preguntas. Sin formularios. Sin drama.</p>

            <div className="inline-block bg-slate-100 text-slate-500 font-bold px-6 py-2 rounded-full text-sm tracking-widest" data-id="element-325">
              TASA DE DEVOLUCIONES MENOR AL 2%
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 12 - FAQ */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-326">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-slate-900 mb-12" data-id="element-327">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-328">
          <AccordionItem question="¿Cómo recibo el material?" answer="Al completar el pago recibís un email con el acceso inmediato a todos los PDFs. En menos de 5 minutos ya podés estar abriendo tu primer tomo. No hay espera. No hay envío físico." data-id="element-329" />
          <AccordionItem question="¿Sirve si soy profe nuevo o si tengo años de experiencia?" answer="Sí para los dos casos. Si sos nuevo: el sistema te da la estructura que no te enseñaron en el curso de profe. Si tenés experiencia: te ahorra las horas que perdés planificando desde cero y le da un marco profesional a lo que ya sabés hacer." data-id="element-330" />
          <AccordionItem question="¿Los 6 Bonus están incluidos en las dos opciones?" answer="Sí. Los 6 Bonus están incluidos tanto en el Pack Profesional ($18.990) como en el Megapack Élite ($27.990). La diferencia entre los dos packs son los 2 Ebooks Élite exclusivos." data-id="element-331" />
          <AccordionItem question="¿Qué diferencia hay con otros materiales que ya existen?" answer="La mayoría de los materiales para profes de pádel son genéricos o están en inglés. PADEL 360 fue diseñado específicamente para el contexto argentino: la forma de enseñar, el vocabulario, los niveles de los clubes y los tipos de alumnos que tiene un profe en Argentina." data-id="element-332" />
          <AccordionItem question="¿Sirve para grupos con niveles mezclados?" answer="Sí. El Bonus 1 (Nivelómetro) fue diseñado exactamente para ese problema. Te permite clasificar a cada alumno en 5 minutos y asignarle el tomo correcto. El Bonus 5 (Kit de Supervivencia) tiene además el protocolo específico para manejar grupos mixtos sin aviso." data-id="element-333" />
          <AccordionItem question="¿Qué pasa si no me sirve?" answer="Tenés 7 días de garantía total. Si abrís el material y no es lo que esperabas, escribinos y te devolvemos el 100% del dinero sin preguntas." data-id="element-334" />
          <AccordionItem question="¿Vale la pena el Megapack Élite si ya planifico bien mis clases?" answer="Si ya planificás bien, el Élite 1 (Programador Maestro) te va a ahorrar igual unas 10 horas de trabajo mensual. Pero el verdadero valor del Megapack Élite está en el Élite 2 (Biblia de las Variantes): más de 100 micro-variantes para que ninguna clase se parezca a la anterior. Eso es lo que fideliza alumnos a largo plazo." data-id="element-335" />
          <AccordionItem question="¿Puedo pagar con tarjeta de crédito?" answer="Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago." data-id="element-336" />
        </div>
      </section>
    </div>;
}
function TestimonialCard({
  initials,
  name,
  city,
  quote
}: {
  initials: string;
  name: string;
  city: string;
  quote: string;
}) {
  return <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm" data-id="element-337">
      <div className="flex items-center gap-4 mb-6" data-id="element-338">
        <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-bold text-lg" data-id="element-339">
          {initials}
        </div>
        <div data-id="element-340">
          <p className="font-bold text-slate-900" data-id="element-341">{name}</p>
          <p className="text-sm text-slate-500" data-id="element-342">{city}</p>
        </div>
      </div>
      <div className="flex text-yellow-400 mb-4" data-id="element-343">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-344" />)}
      </div>
      <p className="text-slate-700 font-medium leading-relaxed" data-id="element-345">"{quote}"</p>
    </div>;
}
function AccordionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-200 rounded-xl bg-white overflow-hidden" data-id="element-346">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-347">
        <span className="font-bold text-slate-900 text-lg pr-4" data-id="element-348">
          {question}
        </span>
        <ChevronDown className={`w-6 h-6 text-slate-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-349" />
      </button>
      <AnimatePresence data-id="element-350">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-351">
            <div className="p-6 pt-0 text-slate-600 font-medium leading-relaxed border-t border-slate-100" data-id="element-352">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}